export var ABTestType;
(function (ABTestType) {
    ABTestType[ABTestType["AB"] = 0] = "AB";
    ABTestType[ABTestType["ABC"] = 1] = "ABC";
    ABTestType[ABTestType["ABCD"] = 2] = "ABCD";
    ABTestType[ABTestType["ABCDE"] = 3] = "ABCDE";
})(ABTestType || (ABTestType = {}));
export var ABTestFeatureName;
(function (ABTestFeatureName) {
    ABTestFeatureName["paxChatV2"] = "storageone__pax_chat_v2";
    ABTestFeatureName["bestaPropping"] = "storage_one__besta_propping";
    ABTestFeatureName["eketPropping"] = "storage_one__eket_propping";
    ABTestFeatureName["paxAutofill"] = "storage_one_pax_autofill";
    ABTestFeatureName["paxAutofillMobile"] = "storage_one_pax__autofill_mobile";
    ABTestFeatureName["paxSummaryAssemblyServices"] = "storage_one_pax__summary_assembly_services";
    ABTestFeatureName["summaryFinancialServices"] = "storage_one__summary_financial_services";
    ABTestFeatureName["platsaOptimizeSpaceDefaultTab"] = "storage_one_platsa_optimize_space_default_tab";
    ABTestFeatureName["paxBumerang"] = "storage_one_pax__bumerang";
    ABTestFeatureName["bestaTopPanelImprovements"] = "storage_one_besta__top_panel_improvements";
    ABTestFeatureName["optimizeSpaceDefault"] = "storage_one__optimize_space_default";
    ABTestFeatureName["bumerangHangers"] = "storage_one__bumerang_hangers";
    ABTestFeatureName["mlSort"] = "storage_one_pax__mlsort_v3";
    ABTestFeatureName["paxGhostFrame"] = "storage_one_pax__ghost_frame";
    ABTestFeatureName["boka"] = "storage_one__boka";
    ABTestFeatureName["testAB"] = "storage_one__test_ab";
    ABTestFeatureName["testAltAB"] = "storage_one__test_alt_ab";
    ABTestFeatureName["testABC"] = "storage_one__test_abc";
    ABTestFeatureName["testAltABC"] = "storage_one__test_alt_abc";
    ABTestFeatureName["testNewSubMenuForPax"] = "storage_one_pax__summary_component_design";
    ABTestFeatureName["animations"] = "storage_one__animations_test";
    ABTestFeatureName["paxImcRenders"] = "storage_one_pax__imc_renders";
    ABTestFeatureName["summaryKompisRelatedProducts"] = "storage_one_pax__kompis_addon";
})(ABTestFeatureName || (ABTestFeatureName = {}));
// The "B" variation is enabled by default
export const ABTestFeatures = {
    [ABTestFeatureName.paxChatV2]: ABTestType.AB,
    [ABTestFeatureName.bestaPropping]: ABTestType.AB,
    [ABTestFeatureName.eketPropping]: ABTestType.AB,
    [ABTestFeatureName.paxAutofill]: ABTestType.AB,
    [ABTestFeatureName.paxAutofillMobile]: ABTestType.AB,
    [ABTestFeatureName.paxSummaryAssemblyServices]: ABTestType.AB,
    [ABTestFeatureName.summaryFinancialServices]: ABTestType.AB,
    [ABTestFeatureName.platsaOptimizeSpaceDefaultTab]: ABTestType.AB,
    [ABTestFeatureName.paxBumerang]: ABTestType.AB,
    [ABTestFeatureName.bestaTopPanelImprovements]: ABTestType.AB,
    [ABTestFeatureName.optimizeSpaceDefault]: ABTestType.AB,
    [ABTestFeatureName.bumerangHangers]: ABTestType.AB,
    [ABTestFeatureName.paxGhostFrame]: ABTestType.AB,
    [ABTestFeatureName.boka]: ABTestType.AB,
    [ABTestFeatureName.mlSort]: ABTestType.AB,
    [ABTestFeatureName.testAB]: ABTestType.AB,
    [ABTestFeatureName.testAltAB]: ABTestType.AB,
    [ABTestFeatureName.testABC]: ABTestType.ABC,
    [ABTestFeatureName.testAltABC]: ABTestType.ABC,
    [ABTestFeatureName.testNewSubMenuForPax]: ABTestType.AB,
    [ABTestFeatureName.animations]: ABTestType.AB,
    [ABTestFeatureName.paxImcRenders]: ABTestType.AB,
    [ABTestFeatureName.summaryKompisRelatedProducts]: ABTestType.AB
};
//# sourceMappingURL=ABTestFeatures.js.map